import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Stethoscope } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-81">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-82">
        <div className="flex items-center gap-2" data-id="element-83">
          <div className="bg-[#0D7377] p-2 rounded-lg" data-id="element-84">
            <Stethoscope className="w-6 h-6 text-white" data-id="element-85" />
          </div>
          <span className={`font-black text-xl tracking-tight ${isScrolled ? 'text-slate-900' : 'text-slate-900'}`} data-id="element-86">
            Sistema PRO
          </span>
        </div>

        <Button href="#comprar" size="sm" className="hidden sm:inline-flex" data-id="element-87">
          Comprar Ahora
        </Button>
      </div>
    </header>;
}